const openNav = document.querySelector('#open-navbar');
const closeNav = document.querySelector('#close-navbar');
const navbar = document.querySelector('#navigation');
const body = document.querySelector('body, html, #close-navbar');

openNav.onclick = function (e) {
    e.stopPropagation();
    navbar.classList.toggle('translate-x-full');
    body.classList.toggle('overflow-hidden');
};

closeNav.onclick = function (e) {
    e.stopPropagation();
    navbar.classList.add('translate-x-full');
    body.classList.remove('overflow-hidden');
};
